import { PhraseMap } from '@ms/yammer-i18n';

const applyStringRebrand = (key: string, json: PhraseMap) => {
  const rebrandedStringSuffix = 'VE';
  const qualifierMatch = key.match(/\|(.*)/);
  const qualifier = qualifierMatch ? qualifierMatch[1] : '';
  const keyWithoutQualifier = key.replace(/\|.*/, '');
  const isRebrandingString = /VE$/.test(keyWithoutQualifier);

  // we're not interested in the rebranded strings themselves
  if (isRebrandingString) {
    return json[key];
  }

  let rebrandedKey = `${keyWithoutQualifier}${rebrandedStringSuffix}`;
  if (qualifier) {
    rebrandedKey += `|${qualifier}`;
  }

  // if the current string has a rebranded version, return that
  if (json[rebrandedKey]) {
    return json[rebrandedKey];
  }

  return json[key];
};

// if the VivaEngageRebranding flight is enabled, overwrite all rebranded strings with the new versions. This allows all
// existing `useTranslation()` hook usages to be unchanged. The old key simply maps to the new one
export const getRebrandedStrings = (phrases: PhraseMap): PhraseMap => {
  const rebrandedStrings: PhraseMap = {};
  Object.keys(phrases).forEach((key) => {
    rebrandedStrings[key] = applyStringRebrand(key, phrases);
  });

  return rebrandedStrings;
};
